import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	icons: {
		iconfont: 'mdi'
	},
	theme: {
		dark: false,
		themes:{
			light:{
				primary: '#663399',
				secondary: '#33CCFF',
				error: '#ff3333',
				success: '#33cc66',
				primary_blue: '#060647',
			}
		}
	}
})
